import React from 'react';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';

export default function WithHistory({ element, ...properties }) {
  const Element = element;
  const history = useHistory();
  return <Element history={history} {...properties} />;
}

WithHistory.propTypes = {
  element: PropTypes.element.isRequired,
};
